import { JsonPipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  setLocalStorage(key, value, encode?: boolean): void {
    if (encode) {
      localStorage.setItem(key, btoa(JSON.stringify(value)));
    } else {
      localStorage.setItem(key, JSON.stringify(value));
    }
  }

  getLocalStorage(key, decode?: boolean): any {
    if (decode) {
      const data = localStorage.getItem(key);
      return data?.length ? JSON.parse(atob(data)) : null;
    } else {
      return JSON.parse(localStorage.getItem(key));
    }
  }

  removeLocalStorage(key): any {
    localStorage.removeItem(key);
  }

  setSessionStorage(key, value): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  getSessionStorage(key): any {
    return JSON.parse(sessionStorage.getItem(key));
  }

  removeSessionStorage(key): any {
    sessionStorage.removeItem(key);
  }

  setCookie(cookieName: string, data: any): void {
    const date = new Date();
    date.setTime(date.getTime() + (30*24*60*60*1000)); // Cookie set for 30 days
    let expires = "expires="+ date.toUTCString();

    // Add Secure and SameSite attributes for GDPR compliance and security
    // Secure: Cookie only sent over HTTPS
    // SameSite=Strict: Prevents CSRF attacks by not sending cookie in cross-site requests
    const securityAttributes = "Secure; SameSite=Strict";

    document.cookie = cookieName + "=" + JSON.stringify(data) + ";" + expires + ";path=/;" + securityAttributes;
  }

  getCookie(cname: string): string {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  deleteCookie(cookieName): void {
    // Include same security attributes when deleting to ensure proper deletion
    document.cookie = cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; Secure; SameSite=Strict";
  }

  setReferralUserDetails(value): void {
    localStorage.setItem("referralUserDetails", JSON.stringify(value));
  }

  removeReferralUserDetails(): void {
    localStorage.removeItem("referralUserDetails");
  }

  getReferralUserDetails() {
    return JSON.parse(localStorage.getItem("referralUserDetails"));
  }
}
